import Relay from 'react-relay'
import ObjectRelObjectsObject from './ObjectRelObjectsObject'

const ObjectRelObjectsObjectContainer = Relay.createContainer(ObjectRelObjectsObject, {
    fragments: {
        object: () => Relay.QL`
            fragment on ObjObjectRelType {
                ObjId,
                ObjObjectNumberTxt,
                ObjObjectNumberGrp_Part1Txt,
                ObjObjectTitleTxt,
                ObjObjectTitleSubTxt,
                ObjDateGrp_DateFromTxt,
                ObjDesigner,
                ObjUrl,
            }
        `
    }
});

export default ObjectRelObjectsObjectContainer;


// WEBPACK FOOTER //
// ./app/components/Object/RelObjects/Object/index.js